import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';

import { MeetingType } from '../../models/MasterMOM';
import Notiflix from "notiflix";


import { UtilityService } from '../../services/utility.service';
import { UserService } from '../../services/user.service';
import { MasterMOMService } from '../../services/master-mom.service';
import { ToastrUtilsService } from './../../services/toastr-utils.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-meeting-type',
  templateUrl: './meeting-type.component.html',
  providers: [ToastrUtilsService]
})
export class MeetingTypeComponent implements OnInit {
  @ViewChild('meetingTypeAdd', { static: false }) meetingTypeAdd: TemplateRef<any>;
  public data: any=[];
  public user_data: any;
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
 
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  model: any = {};
  public permission: number = 1;
  user: any = {};
  login_UserID: number; // number
    modalRef: any;
  public meetingTypeForm: FormGroup;
    dataList: any=[];
    searchText: any;
    noDataImage: string;
  isLoader: boolean = false;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private modalService: BsModalService,
    private userService: UserService,
    private _router: Router,
   ) { }

  ngOnInit() {
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();

    if(user==undefined){
      this.userService.logout();
    }
    else{
      this.login_UserID = user.id;
      var Role = Number(user.role);
      if (Role != 1) {
        this._router.navigate(['/dashboard'])
      }
    }
    
    this.loadMeetingType();
  
    //this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    //if (this.permission == 1) {
    //  this.toolbar = ['Add', 'Edit', 'Delete', 'Search', 'ExcelExport'];
    //}
    //else
    //  this.toolbar = ['Search', 'ExcelExport'];
    //this.pageSettings = { pageSize: 20, pageSizes: true };
    //this.filterSettings = { type: 'Excel' };
  }


  loadMeetingType() {
    //Notiflix.Block.Dots('.pageloadcontainer');
    this.isLoader = true;
   // this.spinner.show();
    let inpValue = new MeetingType();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.login_UserID;
    
    this.momMasterservice.getMeetingType(inpValue)
      .subscribe(data => {
        
        this.data = data;
        this.dataList = data;
        console.log(this.data);
        this.isLoader = false;
      // Notiflix.Block.Remove('.pageloadcontainer', 500);
       // this.spinner.hide();
      },
        () => {
          //Called when error
         // this.spinner.hide();
        //  Notiflix.Block.Remove('.pageloadcontainer', 500);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
       // this.spinner.hide();
       // Notiflix.Block.Remove('.pageloadcontainer', 500);
      });
  }

  exportExcel() {
   

    let items:any=[];
    const wb:any = { SheetNames: [], Sheets: {} };
    let filename = 'master.xlsx';

    
    
    for (var i = 0; i < this.data.length; i++) {
        items.push({
          ID:i+1,
          Meeting_Code: this.data[i].meetingTypecode,
          Meeting_Name: this.data[i].meetingName
        });
      }
      filename = 'MeetingType.xlsx'
      var ws = XLSX.utils.json_to_sheet(items);
    wb.SheetNames.push("meetingtype"); wb.Sheets["meetingtype"] = ws;


    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataVal: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    if (window.navigator.msSaveBlob) //IE & Edge
    {
      //msSaveBlob only available for IE & Edge
      window.navigator.msSaveBlob(dataVal, filename);
    }
    else //Chrome & FF
    {
      var url = window.URL.createObjectURL(dataVal);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
    }
  }

  openModal(template2: TemplateRef<any>, add: any) {
    ;
    this.pageAction = add;
    this.modalRef = this.modalService.show(template2, Object.assign({}, { class: 'gray modal-lg modal-dialog-scrollable' }, this.ngbModalOptions)
    );
    if (this.pageAction == "add") {
      this.model.meetingName = '';
      this.model.meetingTypeCode = '';
    }
    //this.modalPub.hide();
  }
  
 
  
  AddEditMeetingType() {

    ;
    if (this.DuplicateNameCheck(this.utilityService.isStringNull(this.model.meetingTypeCode), this.utilityService.isNumericNull(this.model.meetingTypeUno))) {

      this.toastr.ErrorCustomMessage('Duplicates not allowed');
      return false;
    }
    if (this.model.meetingTypeCode.trim() == '' && this.model.meetingName.trim() == '') {
      this.toastr.ErrorCustomMessage('Please enter required values');
      return false;
    }
      let objMeetingType = new MeetingType();
      objMeetingType.meetingTypeUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(this.model.meetingTypeUno);
    objMeetingType.meetingTypecode = this.utilityService.isStringNull(this.model.meetingTypeCode); 
      objMeetingType.meetingName = this.utilityService.isStringNull(this.model.meetingName);

      objMeetingType.userUno = this.login_UserID;

      
      this.momMasterservice.addEditMeetingType(objMeetingType)
        .subscribe(() => {
          this.toastr.SaveMessage();
          this.loadMeetingType();
          this.modalRef.hide();
          //this.spinner.hide();
        },
          () => {
            //Called when error
            this.toastr.ErrorMessage();
           // this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    
  }

  editMeetingType(data: any) {
    ;
    this.pageAction = "edit";
    this.model.meetingTypeUno = this.utilityService.isNumericNull(data.meetingTypeUno)
    this.model.meetingTypeCode = this.utilityService.isStringNull(data.meetingTypecode);
    this.model.meetingName = this.utilityService.isStringNull(data.meetingName);
  }

  DuplicateNameCheck(meetingTypecode: string, meetingTypeUno: number) {
    var rtnValue = false;
    if (this.data != null && this.data != undefined) {
     
      this.data.forEach((grdData) => {
        //  if (roles.some(role => role.includes(extLink.role))) {
        //    extLink.visible = true;
        //  }
        if (grdData.meetingTypecode.toLocaleLowerCase() == meetingTypecode.toLocaleLowerCase() && meetingTypeUno != grdData.meetingTypeUno) {
          rtnValue = true;
        }
      });

      
    }
    return rtnValue;
  }

  DeleteConfirm(data:any) {
    let temp = this;
    Notiflix.Confirm.Show('Delete Confirm', 'Are you sure you want to delete this record?', 'Yes', 'No', function () {

      Notiflix.Loading.Standard('Loading...');
      temp.DeleteMeetingType(data);

    }, function () { // No button callback
      return false;
    });

  }
  DeleteMeetingType(data1: any) {

    let objMeetingType = new MeetingType();
    objMeetingType.meetingTypeUno = data1.meetingTypeUno;
    objMeetingType.userUno = this.login_UserID;
    //objDeaprtment.tenantUno = 1;
    
    this.momMasterservice.deleteMeetingType(objMeetingType)
      .subscribe(() => {
        
        this.toastr.DeleteMessage();
        this.loadMeetingType();
        Notiflix.Loading.Remove();
        // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();
          //Called when error
         // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }

  searchGrid() {
    ;
    if (this.searchText != "") {
      this.data = this.dataList.filter(a =>
        a.meetingTypecode && a.meetingTypecode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.meetingName && a.meetingName.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.data = this.dataList;
  }
}
